module.exports = __webpack_public_path__ + "static/media/57afd2b87c6a00574dde4becfe9b6b0.44823efa.jpg";